import React, { useEffect, useState } from "react";
import { useStoreState } from "easy-peasy";
import { toRomanianDate } from "../../../utils/dateFormatter";
import _take from "lodash/take";
import { replaceCountyTerms } from "../../../utils/textUtils";

export default function ListaProiecteTable() {
    const projects = useStoreState(
        (state) => state.companyProfile.companyProfile.proiecteMonitorizate
    );

    // --- Moldova flag: OR pe store/local/host (orice TRUE câștigă)
    const storeFlagRaw = useStoreState((s) =>
        s && s.companyProfile ? s.companyProfile.isMoldovaEnvironment : undefined
    );
    const envName =
        typeof window !== "undefined" && window.localStorage
            ? window.localStorage.getItem("ENV_NAME")
            : null;
    const localFlag = !!(envName && /^(md|moldova)$/i.test(envName));
    const hostFlag =
        typeof window !== "undefined" && /\.md\b/i.test(window.location.hostname);
    const isMoldovaEnvironment = storeFlagRaw === true || localFlag || hostFlag;

    const victaBaseUrl = isMoldovaEnvironment
        ? "https://victamoldova.ro"
        : "https://victa.ro";

    const [showCount, setShowCount] = useState(10);
    const [projectsToDisplay, setProjectsToDisplay] = useState([]);

    useEffect(() => {
        if (projects && projects.length) {
            setProjectsToDisplay(_take(projects, showCount));
        }
    }, [projects, showCount]);

    return (
        <div
            className="table-responsive"
            data-toggle="lists"
            data-options='{"valueNames": ["tables-status", "tables-role", "tables-date"]}'
        >
            <div className="d-none d-xs-none d-sm-none d-md-none d-lg-block">
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">
                                <button type="button" className="btn btn-link p-0 text-muted">
                                    Proiect
                                </button>
                            </th>
                            <th scope="col">
                                <button
                                    type="button"
                                    className="btn btn-link p-0 text-muted sort"
                                    data-sort="tables-status"
                                >
                                    Stadiu{" "}
                                </button>
                            </th>
                            <th scope="col">
                                <button
                                    type="button"
                                    className="btn btn-link p-0 text-muted sort"
                                    data-sort="tables-role"
                                >
                                    Rol
                                </button>
                            </th>
                            <th scope="col">
                                <button type="button" className="btn btn-link p-0 text-muted">
                                    {isMoldovaEnvironment ? "Raion" : "Județ"}
                                </button>
                            </th>
                            <th scope="col">
                                <button
                                    type="button"
                                    className="btn btn-link p-0 text-muted sort"
                                    data-sort="tables-date"
                                >
                                    Dată
                                </button>
                            </th>
                            <th scope="col">
                                <button type="button" className="btn btn-link p-0 text-muted">
                                    Link Victa
                                </button>
                            </th>
                        </tr>
                    </thead>
                    <tbody className="list">
                        {projectsToDisplay && projectsToDisplay.length
                            ? projectsToDisplay.map((item) => (
                                <tr key={item.projectNumber}>
                                    <th scope="row">{item.numeProiect}</th>
                                    <td>{item.descriereStadiuProiect}</td>
                                    <td>{item.descriereRolCompanie}</td>
                                    <td>{item.judet}</td>
                                    <td>{toRomanianDate(item.dataUltimeiActualizari)}</td>
                                    <td>
                                        <a
                                            href={`${victaBaseUrl}/app/projects/details/${item.projectNumber}`}
                                            className="text-muted"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Detalii
                                        </a>
                                    </td>
                                </tr>
                            ))
                            : null}
                    </tbody>
                </table>

                {projects && projects.length > showCount ? (
                    <div className="col-2 col-lg-3 col-xl-2 float-right">
                        <button
                            className="btn btn-primary d-block d-md-inline-block lift float-right"
                            onClick={() => setShowCount(showCount + 10)}
                        >
                            Încarcă încă 10 șantiere
                        </button>
                    </div>
                ) : null}
            </div>

            <div className="d-xs-block d-sm-block d-md-block d-lg-none d-block">
                <div className="card-body">
                    {projectsToDisplay
                        ? projectsToDisplay.map((item) => (
                            <div className="row" key={item.projectNumber}>
                                <div className="col-12 pt-3 font-weight-bold">
                                    {item.numeProiect}
                                </div>
                                <div className="col-12 pt-1">
                                    {replaceCountyTerms("Județ", isMoldovaEnvironment)}:{" "}
                                    {item.judet} | Stadiu: {item.descriereStadiuProiect} | Rol:{" "}
                                    {item.descriereRolCompanie} | Dată:{" "}
                                    {toRomanianDate(item.dataUltimeiActualizari)}
                                </div>
                                <div className="col-12 pt-1 font-weight-bold">
                                    <a
                                        href={`${victaBaseUrl}/app/projects/details/${item.projectNumber}`}
                                        className="text-muted"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Detalii proiect pe VICTA{" "}
                                    </a>
                                </div>
                            </div>
                        ))
                        : <div></div>}
                    {projects && projects.length > showCount && (
                        <div className="col-12 float-left pt-5 pl-0">
                            <button
                                className="btn btn-primary d-block d-md-inline-block lift float-left"
                                onClick={() => setShowCount(showCount + 10)}
                            >
                                Încarcă încă 10 șantiere
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
